import React from 'react'
import { useTranslation } from 'react-i18next'
import DeliveryPickup from '@/assets/images/icons/DeliveryPickup.svg'
import Dropoff from '@/assets/images/icons/DropOff.svg'
import HomePickup from '@/assets/images/icons/HomePickup.svg'
import InStore from '@/assets/images/icons/InStore.svg'
import SelfShipping from '@/assets/images/icons/SelfShipping.svg'
import { PbLogisticsSummaryReturnMethodEnum } from '@itsrever/rever-api'
import { Base } from '@itsrever/design-system'

interface ReturnMethodTagProps {
  method: PbLogisticsSummaryReturnMethodEnum
}

const iconSource = (method: PbLogisticsSummaryReturnMethodEnum) => {
  switch (method) {
    case PbLogisticsSummaryReturnMethodEnum.DropOff:
      return <img src={Dropoff} className="size-3" />
    case PbLogisticsSummaryReturnMethodEnum.DeliveryPickup:
      return <img src={DeliveryPickup} className="size-3" />
    case PbLogisticsSummaryReturnMethodEnum.PickUp:
      return <img src={HomePickup} className="size-3" />
    case PbLogisticsSummaryReturnMethodEnum.InStore:
      return <img src={InStore} className="size-3" />
    case PbLogisticsSummaryReturnMethodEnum.SelfShipping:
      return <img src={SelfShipping} className="size-3" />
    default:
      return null
  }
}

const ReturnMethodTag: React.FC<ReturnMethodTagProps> = ({ method }) => {
  const { t } = useTranslation()

  return (
    <Base.Badge icon={iconSource(method)}>
      {t(`return_methods.${method}`)}
    </Base.Badge>
  )
}

export default ReturnMethodTag
